export default {
  setSelectedNode: (state, node) => { state.selectedNode = node },
  setSelectedGraph: (state, graph) => { state.selectedGraph = graph },
  setSchool: (state, school) => { state.school = school },
}
